var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgPhotoBoothTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 316.44 329.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6abeec;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.08,36.78C147.22,26.5,121.4,22.16,95.73,21c-10.06-.48-20.24-.47-30,1.94-21.42,5.27-39.25,22-49.48,42.51S2.82,109.69,4,132.9c.94,19,10.46,39.58,26.19,49.18,12.32,7.51,42.26,8.42,47.43,17.55,26.91,47.52-3,58.91,21.54,83.79,12.33,12.48,21.83,37.25,32.33,39.09,29.65,5.18,36,6.86,61.3,3.07,19.18-2.87,35.67-12.42,48.91-27.2s16.23-33.21,18.16-53.37,4.74-51.88,3-72.1c-3.12-35.19-.37-51.39-20.09-82.06-6.42-10-16.43-16.62-25.4-23.76C202.54,55.33,188.34,44.22,171.08,36.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.85,20.07c11.53,12,13.74,26.77,10,42C307.67,78.7,286.33,86.48,269,81s-30.2-20.91-37.35-37.28a21,21,0,0,1-2.23-8.42c0-3.28,1.54-6.31,3.37-9,7.58-11,20.81-17,34.06-20.78,9.29-2.66,21.78-3.33,27.11,5.05C294,10.58,298.41,16.49,301.85,20.07Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPhotoBoothTop);
export default __webpack_public_path__ + "static/media/bg_photo_booth_top.165e9f5f8c27cbb822aa151e4ac0f955.svg";
export { ForwardRef as ReactComponent };